function getTitle(vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

export default {
  watch: {
    $route(to, from) {
      this.doTitle()
    }
  },
  mounted() {
    this.doTitle()
  },
  methods: {
    doTitle() {
      const title = getTitle(this)
      if (title) {
        document.title = title + ' « ' + this.$store.getters.ecosystem.siteName
      }
    }
  }
}
